import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

export interface INews {
    content?: string
    created_at: number
    id: string
    is_active?: boolean
    language?: string
    link?: string
    owner?: {
        name?: string
        thumbnail?: string
    }
    priority?: number
    thumbnail?: string
    title?: string
    type?: string
}

export const getNewsList = async (): Promise<ApiRes<INews[]>> => {
    return await apiGet(API_URL, `admin/hub/trending`)
}
